import React from 'react';
import { Droplets, FileText, Wrench, Search } from 'lucide-react';
export function WhyBuy() {
  const features = [{
    icon: <Droplets className="w-8 h-8 text-copper" data-id="element-157" />,
    title: 'Freshwater Only',
    description: 'Operated exclusively on Lake George, benefiting from freshwater use and careful seasonal storage.'
  }, {
    icon: <FileText className="w-8 h-8 text-copper" data-id="element-158" />,
    title: 'Documented History',
    description: 'Each vessel includes documented maintenance history available upon request.'
  }, {
    icon: <Wrench className="w-8 h-8 text-copper" data-id="element-159" />,
    title: 'Pro Technicians',
    description: 'Maintained by experienced marine technicians on a consistent preventative service schedule.'
  }, {
    icon: <Search className="w-8 h-8 text-copper" data-id="element-160" />,
    title: 'Regular Inspections',
    description: 'Cleaned regularly and inspected thoroughly throughout their time in the fleet.'
  }];
  return <section className="py-20 px-6 md:px-12 bg-white" data-id="element-161">
      <div className="max-w-7xl mx-auto" data-id="element-162">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-163">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-164">
            The Advantage of Buying a Freedom Boat Club Fleet Boat
          </h2>
          <p className="text-navy-600 text-lg leading-relaxed" data-id="element-165">
            Freedom Boat Club boats are maintained by experienced marine
            technicians on a consistent preventative service schedule and
            cleaned regularly throughout their time in the fleet. Because these
            boats are operated exclusively on Lake George, they benefit from
            freshwater use and careful seasonal storage. Each vessel includes
            documented maintenance history and has been professionally cared for
            to support reliability, performance, and long-term value for its
            next owner. Their structured maintenance approach means every boat
            receives more consistent service oversight than most privately owned
            vessels.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-166">
          {features.map((feature, idx) => <div key={idx} className="bg-cream rounded-2xl p-8 text-center hover:shadow-md transition-shadow" data-id="element-167">
              <div className="bg-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 shadow-sm" data-id="element-168">
                {feature.icon}
              </div>
              <h3 className="text-xl font-heading font-semibold text-navy mb-3" data-id="element-169">
                {feature.title}
              </h3>
              <p className="text-navy-600 text-sm leading-relaxed" data-id="element-170">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}